import { IS_BROWSER } from "@/lib/browserUtils";

// 1×1 lossy WebP; decoding is checked, not canvas encoding — Safari decodes WebP but does not encode it
const WEBP_PROBE = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";

let support: Promise<boolean> | undefined;

export function detectWebpSupport(): Promise<boolean> {
  if (!IS_BROWSER) return Promise.resolve(false);
  if (!support) {
    support = new Promise(resolve => {
      const image = new Image();
      image.onload = () => resolve(image.width === 1);
      image.onerror = () => resolve(false);
      image.src = WEBP_PROBE;
    });
  }
  return support;
}
